import { ILbl } from "../lbl/ILbl";
import { IOrder } from "./IOrder";
import { Order  } from "./Order";
import { ISelector } from "../selector/ISelector"

export interface IAdresOdbiorcy {
    adres: string
    faktury: number
    odbiorca_idn: string
    podst: number
    wysyłki: number
    text:string
}




export class order_api {

    public static start_flow_montaz:string= "/api/order/start_flow_montaz"
    public static create_order:string= "/api/order/create_order"
    public static create_nowy_w_erp:string = "/api/order/create_nowy_w_erp"
    public static get_adresy_odbiorcy:string="/api/order/get_adresy_odbiorcy"
    public static find_by_id:string = "/api/order/find_by_id";
    public static update_order:string = "/api/order/update";
    public static get_orders:string = "/api/order/get_orders";

}

export interface IOrderSvc {
    start_flow_montaz(order: IOrder): Promise<IOrder | undefined> 
    update_order(order: IOrder): Promise<IOrder | undefined> 
    create_order(lbls: ILbl[]): Promise<IOrder | undefined> 
    create_nowy_w_erp(order: IOrder): Promise<IOrder | undefined> 
    get_adresy_odbiorcy(odbiorca_idn:string): Promise<IAdresOdbiorcy[]> 
    find_by_id(_id: any): Promise<IOrder | undefined> 
    get_orders( selector: ISelector):Promise<IOrder[]> 
}